import styled from 'styled-components';

const ContactPageContainer = styled.div`
    padding-top: var(--section-padding);
    padding-bottom: var(--section-padding);
    .content {
        display: flex;
        justify-content: space-between;
        @media (max-width: 767px) {
            flex-direction: column;
        }
        form {
            flex-basis: 70%;
            .main-input {
                padding: 20px;
                display: block;
                border: 1px solid #ccc;
                margin-bottom: 30px;
                width: 100%;
                &:focus {
                    outline: none;
                }
            }
            textarea.main-input {
                height: 200px;
                resize: none;
            }
            input[type='submit'] {
                background-color: var(--main-color);
                color: white;
                padding: 20px;
                border: none;
                display: flex;
                margin-left: auto;
                text-transform: uppercase;
                cursor: pointer;
            }
        }
    }
    .content .info {
        flex-basis: 25%;
        @media (max-width: 767px) {
            order: -1;
            text-align: center;
        }
        h4 {
            text-transform: uppercase;
            margin-bottom: 30px;
            font-weight: 500;
            font-size: 18px;
            &:nth-of-type(2) {
                margin-top: 90px;
                @media (max-width: 767px) {
                    margin-top: 30px;
                }
            }
        }
        .phone {
            display: block;
            color: #777;
            margin-bottom: 10px;
        }
    }
    .content .info address {
        color: #777;
        line-height: 2;
        @media (max-width: 767px) {
            margin-bottom: 40px;
        }
    }
`;
export default ContactPageContainer;
